module.exports = __webpack_public_path__ + "static/media/municipio-reggio-emilia.d231b1bb.svg";